/* RS Air Filter — cards do catálogo: injeta vídeo da 1ª/2ª mídia (estilo Manto)
   - 1ª mídia em vídeo  -> autoplay/mudo/loop já animado no card (toca quando visível)
   - 2ª mídia em vídeo  -> imagem normal + troca pro vídeo no hover (desktop) / revela na viewport (mobile)
   - sem vídeo          -> mantém a troca de imagens nativa
   Proporção: o vídeo preenche a mesma caixa da imagem (settings.product_aspect_ratio), object-fit cover, sem quebrar o grid. */
(function(){
  var canHover = window.matchMedia && window.matchMedia('(hover:hover)').matches;
  var cache = {};

  function getProduct(handle){
    if(cache[handle]) return cache[handle];
    cache[handle] = fetch('/products/'+handle+'.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.ok ? r.json() : null; }).catch(function(){ return null; });
    return cache[handle];
  }
  function mp4Of(media){
    if(!media || media.media_type!=='video' || !media.sources || !media.sources.length) return null;
    var s = media.sources.filter(function(x){ return /mp4/i.test(x.format||x.mime_type||''); })[0] || media.sources[0];
    return s ? s.url : null;
  }
  function buildVid(url, poster){
    var w=document.createElement('div'); w.className='rs-card-vid';
    var v=document.createElement('video');
    v.muted=true; v.loop=true; v.playsInline=true; v.preload='metadata';
    v.setAttribute('muted',''); v.setAttribute('loop',''); v.setAttribute('playsinline',''); v.setAttribute('webkit-playsinline','');
    if(poster) v.poster=poster;
    var s=document.createElement('source'); s.src=url; s.type='video/mp4'; v.appendChild(s);
    w.appendChild(v); return w;
  }

  var playIO=new IntersectionObserver(function(es){
    es.forEach(function(en){
      var v=en.target.querySelector('video'); if(!v) return;
      var playable = en.target.classList.contains('rs-card-vid--main') || en.target.classList.contains('rs-show');
      if(en.isIntersecting && playable){ var p=v.play(); if(p&&p.catch)p.catch(function(){}); }
      else { v.pause(); }
    });
  },{threshold:0.25});

  function apply(card, p){
    if(!p || !p.media || !p.media.length) return;
    var m0=p.media[0], m1=p.media[1];
    var url=null, kind=null, poster=null;
    if(m0 && m0.media_type==='video'){ url=mp4Of(m0); kind='main'; poster=m0.preview_image && m0.preview_image.src; }
    else if(m1 && m1.media_type==='video'){ url=mp4Of(m1); kind='hover'; poster=m1.preview_image && m1.preview_image.src; }
    if(!url) return;
    // .tp__img-url é display:inline (âncora errada p/ absolute) — usar o wrapper block da mídia
    var box=card.querySelector('.tp__product-main-img') || card.querySelector('.card__media') || card.querySelector('.tp__img-url') || card.querySelector('a[href*="/products/"]');
    if(!box) return;
    if(getComputedStyle(box).position==='static') box.style.position='relative';
    var w=buildVid(url, poster); w.classList.add('rs-card-vid--'+kind);
    box.appendChild(w);
    var v=w.querySelector('video'); try{ v.load(); }catch(e){}
    if(kind==='main'){ playIO.observe(w); }
    else {
      if(canHover){
        card.addEventListener('mouseenter', function(){ var pr=v.play(); if(pr&&pr.catch)pr.catch(function(){}); });
        card.addEventListener('mouseleave', function(){ v.pause(); try{v.currentTime=0;}catch(e){} });
      } else { w.classList.add('rs-show'); playIO.observe(w); }
    }
  }

  function process(card){
    if(card.dataset.rsCardV) return;
    var a=card.querySelector('a.tp__img-url') || card.querySelector('a[href*="/products/"]');
    if(!a) return;
    var m=(a.getAttribute('href')||'').match(/\/products\/([^\/?#]+)/);
    if(!m) return;
    card.dataset.rsCardV='1';
    getProduct(m[1]).then(function(p){ apply(card, p); });
  }

  var cardIO=new IntersectionObserver(function(es){
    es.forEach(function(en){ if(en.isIntersecting){ process(en.target); cardIO.unobserve(en.target); } });
  },{rootMargin:'250px'});

  function inView(el){ var r=el.getBoundingClientRect(); return r.top < (window.innerHeight+400) && r.bottom > -400; }
  function scan(){
    document.querySelectorAll('.product-card-wrapper, .tp-prd-item').forEach(function(c){
      if(c.dataset.rsCardV || c.dataset.rsCardSeen) return;
      c.dataset.rsCardSeen='1';
      if(inView(c)) process(c); else cardIO.observe(c);
    });
  }

  if(document.readyState!=='loading') scan();
  document.addEventListener('DOMContentLoaded', scan);
  document.addEventListener('shopify:section:load', scan);
  var t; var mo=new MutationObserver(function(){ clearTimeout(t); t=setTimeout(scan, 300); });
  if(document.body) mo.observe(document.body, {childList:true, subtree:true});
})();
